module.exports = __webpack_public_path__ + "iPad_mini.svg?7cd883ed1f4bb3ec00be9be3a7ccaba7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPad_mini.svg
// module id = 223
// module chunks = 0